export class UserModal {
    _id?: String;
    partnerId?: String;
    username?: String;
    name?: String;
    type?: String;
    commission?: Number;
    email?: String;
    phone?: String;
    password?: String;
    role?: String;
    status?: String;
    logoPath?: String;
    address?: String;
    createdAt?: Number;
    updatedAt?: Number;
}